/**
 * Created by Paul on 2017-06-19.
 */
import _ from "lodash";
const isArrayLike = (item) => {
    return (Array.isArray(item) ||
        (!!item &&
            typeof item === "object" &&
            "length" in item &&
            typeof item.length === "number" &&
            (item.length === 0 || (item.length > 0 && item.length - 1 in item))));
};
export const firstNotNullEmptyArray = (...arrays) => {
    for (const array of arrays) {
        if (notNullEmptyArray(array)) {
            return array;
        }
    }
    return undefined;
};
export const notNullEmptyArray = (array) => {
    return array != null && isArrayLike(array) && array.length > 0;
};
export const nullEmptyArray = (array) => {
    return !notNullEmptyArray(array);
};
function firstElementOrNull(array) {
    if (notNullEmptyArray(array)) {
        return array[0];
    }
    return null;
}
const safeIterate = (array, iterator) => {
    if (notNullEmptyArray(array)) {
        array.forEach(iterator);
    }
};
function safeFmap(array, fmapIterator) {
    if (notNullEmptyArray(array)) {
        return fmapCall.call(array, fmapIterator);
    }
    return [];
}
function safeMap(array, mapIterator) {
    if (notNullEmptyArray(array)) {
        return array.map(mapIterator);
    }
    return null;
}
export function fmapCall(callback) {
    return this.reduce((accum, ...args) => {
        const x = callback(...args);
        if (x != null) {
            accum.push(x);
        }
        return accum;
    }, []);
}
function subArrayGroups(array, keyOrFunc) {
    return Object.values(_.groupBy(array, keyOrFunc));
}
function subGroupIterate(array, groupSize, iterateFunction) {
    const cutArray = array.slice();
    while (cutArray.length > 0) {
        iterateFunction(cutArray.splice(0, groupSize));
    }
}
async function subGroupIterateAsync(array, groupSize, iterateFunction) {
    const cutArray = array.slice();
    while (cutArray.length > 0) {
        await iterateFunction(cutArray.splice(0, groupSize));
    }
}
const hasIntersection = (arrayOne, arrayTwo) => {
    if (arrayOne.length > arrayTwo.length) {
        for (const item of arrayTwo) {
            if (arrayOne.includes(item)) {
                return true;
            }
        }
    }
    else {
        for (const item of arrayOne) {
            if (arrayTwo.includes(item)) {
                return true;
            }
        }
    }
    return false;
};
const deepFMap = (array, deepMapFunction, mapAtDepth = null, startingDepthCounter = 1) => {
    return fmapCall.call(array, (v, i) => {
        if (mapAtDepth != null && startingDepthCounter === mapAtDepth) {
            return deepMapFunction(v, i, startingDepthCounter);
        }
        if (ArrayUtils.isArrayLike(v)) {
            return deepFMap(v, deepMapFunction, mapAtDepth, startingDepthCounter + 1);
        }
        else {
            return deepMapFunction(v, i, startingDepthCounter);
        }
    });
};
function sortNumbers(array, desc = false) {
    if (desc) {
        return array.sort((a, b) => b - a);
    }
    return array.sort((a, b) => a - b);
}
export const notNull = (item) => item != null;
function pushAndReturn(array, ...items) {
    if (!array) {
        array = [];
    }
    array.push(...items);
    return array;
}
function spliceAndReturn(array, index, count) {
    array.splice(index, count);
    return array;
}
function pushOrCreateOnObject(obj, key, item) {
    if (obj[key] == null) {
        obj[key] = [];
    }
    obj[key].push(item);
}
function indexOfMatchedPredicate(array, item, matchPredicate) {
    if (typeof matchPredicate === "string") {
        let index = -1;
        for (const i of array) {
            index += 1;
            if (i[matchPredicate] === item[matchPredicate]) {
                return index;
            }
        }
    }
    else if (Array.isArray(matchPredicate)) {
        let index = -1;
        for (const i of array) {
            index += 1;
            if (_.get(i, matchPredicate) === _.get(item, matchPredicate)) {
                return index;
            }
        }
    }
    else {
        let index = -1;
        for (const i of array) {
            index += 1;
            if (matchPredicate(i, item)) {
                return index;
            }
        }
    }
    return -1;
}
function addIfMissing(array, item, matchPredicate) {
    if (Array.isArray(item)) {
        for (const i of item) {
            addIfMissing(array, i, matchPredicate);
        }
    }
    else {
        if (matchPredicate) {
            if (indexOfMatchedPredicate(array, item, matchPredicate) >= 0) {
                return array;
            }
            /*if (typeof matchPredicate === "string") {
              for (const i of array) {
                if (i[matchPredicate] === item[matchPredicate]) {
                  return array;
                }
              }
            } else if (Array.isArray(matchPredicate)) {
              for (const i of array) {
                if (_.get(i, matchPredicate) === _.get(item, matchPredicate)) {
                  return array;
                }
              }
            } else {
              for (const i of array) {
                if (matchPredicate(i, item)) {
                  return array;
                }
              }
            }*/
            array.push(item);
            return array;
        }
        if (!array.includes(item)) {
            array.push(item);
        }
    }
    return array;
}
function toggleItems(array, item, matchPredicate) {
    if (Array.isArray(item)) {
        for (const i of item) {
            toggleItems(array, i);
        }
    }
    else {
        let matchedIndex;
        if (matchPredicate) {
            matchedIndex = indexOfMatchedPredicate(array, item, matchPredicate);
        }
        else {
            matchedIndex = array.indexOf(item);
        }
        if (matchedIndex >= 0) {
            array.splice(matchedIndex, 1);
        }
        else {
            array.push(item);
        }
    }
    return array;
}
export function last(array) {
    return array[array.length - 1];
}
function removeUndefinedOrNull(array) {
    return safeFmap(array, (i) => i);
}
function collectProperty(array, itemProperty) {
    const collectSet = new Set();
    for (const item of array) {
        collectSet.add(item[itemProperty]);
    }
    return [...collectSet];
}
export const ArrayUtils = {
    collectProperty,
    subArrayGroups,
    hasIntersection,
    isArrayLike,
    deepFMap,
    notNullEmptyArray,
    nullEmptyArray,
    firstElementOrNull,
    safeIterate,
    safeFmap,
    safeMap,
    subGroupIterate,
    subGroupIterateAsync,
    sortNumbers,
    pushOrCreateOnObject,
    addIfMissing,
    toggleItems,
    pushAndReturn,
    spliceAndReturn,
    removeUndefinedOrNull,
};
